export default __webpack_public_path__ + "static/media/Shadow's Tunic of Whispered Deeds.92b2b691.jpg";